'use client';

import { parseAsString, useQueryState } from 'nuqs';

import { PageHeader } from '@/app/(app)/page-main';
import { OfficeGeneral } from '@/app/(app)/settings/office/office-general';
import { OfficeHours } from '@/app/(app)/settings/office/office-hours';
import { OfficeLocation } from '@/app/(app)/settings/office/office-location';
import OfficeScheduling from '@/app/(app)/settings/office/office-scheduling';
import { OfficeEditingProvider } from '@/app/(app)/settings/office/provider';
import { PageTabsList, PageTabsTrigger, Tabs, TabsContent } from '@/components/ui/tabs';

export function OfficePage() {
  return (
    <OfficeEditingProvider>
      <PageContent />
    </OfficeEditingProvider>
  );
}

function PageContent() {
  const [tab, setTab] = useQueryState('tab', parseAsString.withDefault('general'));

  return (
    <Tabs value={tab} onValueChange={(value) => setTab(value as typeof tab)}>
      <div>
        <PageHeader title='Office' breadcrumbs={[{ label: 'Settings', href: '/settings' }]} />
        <div className='mt-2 border-b-[0.5px] px-4'>
          <PageTabsList className=''>
            <PageTabsTrigger value='general'>General</PageTabsTrigger>
            <PageTabsTrigger value='location'>Location</PageTabsTrigger>
            <PageTabsTrigger value='scheduling'>Scheduling</PageTabsTrigger>
            <PageTabsTrigger value='hours'>Office Hours</PageTabsTrigger>
          </PageTabsList>
        </div>
        <div className='mx-auto mt-14 w-full max-w-2xl'>
          <TabsContent value='general'>
            <OfficeGeneral />
          </TabsContent>
          <TabsContent value='location'>
            <OfficeLocation />
          </TabsContent>
          <TabsContent value='scheduling'>
            <OfficeScheduling />
          </TabsContent>
          <TabsContent value='hours'>
            <OfficeHours />
          </TabsContent>
        </div>
      </div>
    </Tabs>
  );
}
